module.exports = __webpack_public_path__ + "img/image8.1b90f9f5.svg";